import type {Part} from 'schemaDefinition/types';
import type {
  AgentCorporation,
  AgentEvent,
  AgentPerson,
} from 'services/agent/types';

type BareAgent = Pick<
  AgentPerson | AgentCorporation | AgentEvent,
  'isni' | 'nationalId'
>;

export const agentBAREParts: Part<BareAgent>[] = [
  {
    type: 'text',
    name: 'isni',
  },
  {
    type: 'text',
    name: 'nationalId',
    readonly: true,
    prefix: 'icon:Verified',
    prefixOnEmpty: 'icon:None',
  },
];
